var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-black rounded-full h-125 w-125 flex flex-col items-center justify-center"},[_c('p',{staticClass:"h1"},[_vm._v(_vm._s(_vm.emoji))]),_c('p',{staticClass:"text-white font-semibold"},[_vm._v(_vm._s(_vm.genderName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }